/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'

export const myPageV4Schema = z
  .object({
    type: z
      .string()
      .min(1)
      .default('')
      .describe('Page identifier — a EP.Lib.Constants.UIPagesV4 constant.'),
    events: z
      .int()
      .default(0)
      .describe('Events badge count for the page; -1 when the page has no events function.'),
  })
  .describe('One UI page available to the user in the active context, with its events badge.')
